"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignoreDescriptor = void 0;
var tslib_1 = require("tslib");
var APIError_js_1 = require("../../errors/APIError.js");
function ignoreDescriptor(callback, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isDescriptorNotSupportedError, descriptor, clonedData;
        return tslib_1.__generator(this, function (_a) {
            try {
                return [2 /*return*/, callback(data)];
            }
            catch (error) {
                isDescriptorNotSupportedError = error.errorResponse.code === APIError_js_1.ResponseErrorCode.ValidationError &&
                    error.errorResponse.errors.length === 1 &&
                    error.errorResponse.errors.find(function (e) { return e.field === "descriptor" && e.reason === APIError_js_1.ResponseErrorCode.NotSupportedByProcessor; });
                if (isDescriptorNotSupportedError) {
                    descriptor = data.descriptor, clonedData = tslib_1.__rest(data, ["descriptor"]);
                    return [2 /*return*/, callback(clonedData)];
                }
                else {
                    throw error;
                }
            }
            return [2 /*return*/];
        });
    });
}
exports.ignoreDescriptor = ignoreDescriptor;
//# sourceMappingURL=ignoreDescriptor.js.map